module.exports = __webpack_public_path__ + "img-dashboard/register/crown.bcab3ecc.png";